// This provide type safety
export const UserType: {
  NONE: number
  AUDIENCE: number
  BROADCASTER: number
  MODERATOR: number,
  AVATAR: 4
} = window.MeetOnline.UserType

export const ActionType = {
  ADD: "ADD",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  RESET: "RESET",
  DOWNLOAD: "DOWNLOAD"
}

export const AppStatus: {
  USER_LEAVE: number
  OK: 1
  FAILS: 2
  IN_PROGRESS: 3
  WEBSOCKET_PING_TIMEOUT: number
  WEBSOCKET_DISCONNECTED: number
  NETWORK_ERROR: number
  WEBSOCKET_AUTH_RECONNECTION: number
  ROOM_DURATION_TIMEOUT: number
  SERVER_ERROR: number
  MISSING_ENTITLEMENT: number
  RESTRICTED_PERSONAL_ROOM: number
  ONE_USER_LIMIT_PERSONAL_ROOM: number
} = window.MeetOnline.AppStatus

export const ErrorCode = window.MeetOnline.ErrorCode

export const DomError = {
  NOT_ALLOWED_ERROR: 'NotAllowedError'
}

export const ConnectionStatus: {
  DISCONNECTED: number;
  CONNECTING: number;
  AUTHORIZED: number;
  CONNECTED: number;
  INCALL: number;
  OFFLINE: number;
  DISCONNECTING: number;
  RECONNECTING: number;
} = window.MeetOnline.UserStatus

export const SubdomainPageType = {
	NONE: 0,
	PROFILE: 1,
	GRID: 2,
} as const

export const TabButtonPosition = {
	BOTTOM: 0,
	TOP: 1
} as const

export enum initialVideoResolutionOnMobileValues {
  REGULAR_16_9 = 0,
  SQUARE = 1,
  FULLSCREEN = 2
}

export enum checkoutPageTypeValues {
  defaultCheckoutPage = 1,
  productCheckoutPage = 2
}

export const SortType = {
  HIGHEST_PRICE: "highestPrice",
  LOWEST_PRICE: "lowestPrice",
  ALPHABETICALLY: "alphabetically",
  TIMESTAMP: "timestamp"
}

export const ElementId = {
  PIP_VIDEO: "pipVideo",
  FLOATING_VIDEO_BUTTON_CONTAINER: "floating-video-button-container",
  FLOATING_VIDEO_RESIZE_ICON: "floating-video-resize-icon",
  ON_WHOLESCREEN_VIDEO_CONTAINER: "on-wholescreen-video-container",
  FEATURE_OVERLAY: "fade-badge",
  WATCH_PARTY_VIDEO: "watchpartyvideoplayer",
  MOBILE_CHAT_CONTAINER: "mobile-list-chat",
  MOBILE_CHAT_INPUT: "mobile-chat-input"
} as const

export const ModNotPresentType = {
  VIDEO: "modNotPresentVideo",
  IMAGE: "modNotPresentImage",
  OVERLAY: "modNotPresentOverlay"
} as const

export const DURATION_TIMER_STATE = {
  PAUSE: 0,
  START: 1
} as const

export const SESSION_END_LAYOUT = {
  PAGE: 1,
  MODAL: 2
} as const;

export const PRODUCT_DESTINATION = {
  LIVESELL_PIP: 1,
  LIVESELL_IFRAME: 2,
  EXTERNAL_WITH_NO_MINIPLAYER: 3, // Neither PiP nor iFrame
  NATIVE_APP: 4,
  PARENT_IFRAME: 5,
}

export const STREAM_RECORD_ACTION = {
  START: "start",
  STOP: "stop"
} as const;
